<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="PreferredLocationFormRef" @submit.prevent>
        <v-card class="form-card">
          <div class="dialog-header">
            <div>
              <div class="dialog-header-title">
                {{ action }} Student Demerit
              </div>
              <div class="dialog-header-sub">Fill in the details below</div>
            </div>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </div>

          <v-card-text class="form-body">
            <v-container class="pa-0">
              <v-row dense>
                <v-col cols="12">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-format-title</v-icon>
                    Student
                  </div>
                  <v-autocomplete
                    v-model="student_selected"
                    :items="student_list"
                    item-value="id"
                    item-title="name"
                    placeholder="Please select student"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="#16a34a"
                    class="rounded-lg"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-tag-outline</v-icon>
                    Type
                  </div>
                  <v-autocomplete
                    v-model="type_selected"
                    :items="type_list"
                    item-value="value"
                    :item-title="'text'"
                    placeholder="Please select type"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="#16a34a"
                    class="rounded-lg"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-calendar</v-icon>
                    Date
                  </div>
                  <v-text-field
                    :model-value="formatDate(date_)"
                    variant="outlined"
                    density="compact"
                    readonly
                    hide-details="auto"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    @click="showDatePicker1 = true"
                  ></v-text-field>

                  <v-dialog v-model="showDatePicker1" max-width="290">
                    <v-date-picker
                      v-model="date_"
                      @update:model-value="saveDate"
                      color="#16a34a"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1"
                      >mdi-map-marker-outline</v-icon
                    >
                    {{
                      type_selected == 1 ? "Hours to Add" : "Score to Deduct"
                    }}
                  </div>
                  <v-text-field
                    v-model="demerits"
                    :rules="[formRules.required]"
                    variant="outlined"
                    type="number"
                    density="compact"
                    hide-details="auto"
                    color="#16a34a"
                    class="rounded-lg"
                  />
                </v-col>

                <v-col cols="12">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1"
                      >mdi-map-marker-outline</v-icon
                    >
                    Reason
                  </div>
                  <v-textarea
                    v-model="reason"
                    :rules="[formRules.required]"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#16a34a"
                    class="rounded-lg"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn class="cancel-btn" elevation="0" @click="closeD()">
              <v-icon size="16" class="mr-1">mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              class="save-btn"
              elevation="0"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon size="16" class="mr-1">mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    student_batch_id: String,
    action: String,
  },
  data() {
    return {
      showDatePicker1: false,
      showTimePicker1: false,
      showTimePicker2: false,
      student_selected: null,
      dialog: false,
      btnLoading: false,
      title: null,
      type_selected: null,
      date_: null,
      reason: null,
      demerits: null,
      type_list: [
        { text: "Additional Duty Hours", value: "1" },
        { text: "Deduction to Evaluation Score", value: "2" },
      ],
      student_list: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.getStudents();
        if (data.id) {
          this.student_selected = data.student_id.toString();
          this.type_selected = data.demerit_type;
          this.date_ = data.date_;
          this.demerits = data.demerits;
          this.reason = data.reason;
        } else {
          console.log("data", data);
          this.$nextTick(() => {
            this.student_selected = null;
            this.type_selected = null;
            this.date_ = null;
            this.reason = null;
            this.demerits = null;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    // getTypeColor(type) {
    //   const palette = {
    //     orientation: { text: "#1d4ed8", bg: "#dbeafe" },
    //     seminar: { text: "#ea580c", bg: "#ffedd5" },
    //     meeting: { text: "#0284c7", bg: "#e0f2fe" },
    //   };
    //   const key = (type || "").toLowerCase().replace(/\s+/g, "_");
    //   return palette[key] || { text: "#15803d", bg: "#dcfce7" };
    // },

    typeLabel(value) {
      const match = this.type_list.find((t) => t.value === value);
      return match ? match.text : value;
    },

    saveDate() {
      if (this.date_) {
        this.date_ = this.formatDate3(this.date_);
        this.showDatePicker1 = false;
      }
    },

    getStudents() {
      this.axiosCall(
        "/student/getAllStudentsListByBatch/" + this.student_batch_id,
        "GET",
      ).then((res) => {
        console.log(res.data);
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.student_list = data;
      });
    },

    async save() {
      let formValid = await this.$refs.PreferredLocationFormRef.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          student_id: this.student_selected,
          demerit_type: this.type_selected,
          date_: this.date_,
          reason: this.reason,
          demerits: this.demerits,
        };

        this.axiosCall("/student/add-demerits", "POST", data).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    // async update() {
    //   let formValid = await this.$refs.PreferredLocationFormRef.validate();

    //   if (formValid.valid) {
    //     this.btnLoading = true;
    //     let data = {
    //       student_id: this.student_selected,
    //       demerit_type: this.type_selected,
    //       date_: this.date_,
    //       reason: this.reason,
    //       demerits: this.demerits,
    //     };

    //     this.axiosCall(
    //       "/attendance/student-prac-attendances-update/" + this.data.id,
    //       "PATCH",
    //       data,
    //     ).then((res) => {
    //       console.log(res);
    //       if (res.data.status == 200) {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "success";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.fadeAwayMessage.header = "System Message";
    //         this.btnLoading = false;
    //         this.closeD();
    //       } else {
    //         this.btnLoading = false;
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.fadeAwayMessage.header = "System Message";
    //       }
    //     });
    //   }
    // },

    closeD() {
      eventBus.emit("closeStudentDemeritsDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

.form-card {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  border-radius: 14px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #16a34a;
  color: #fff;
  padding: 18px 20px;
}
.dialog-header-title {
  font-size: 16px;
  font-weight: 700;
}
.dialog-header-sub {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 2px;
}

.form-body {
  padding: 20px !important;
  max-height: 65vh;
}

.field-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 6px;
}

.type-preview {
  display: inline-flex;
  margin-top: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
}

.dialog-actions {
  padding: 14px 20px !important;
}

.cancel-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  text-transform: none !important;
  height: 36px !important;
  padding: 0 16px !important;
}

.save-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #16a34a !important;
  color: #fff !important;
  text-transform: none !important;
  height: 36px !important;
  padding: 0 16px !important;
}
</style>
S